export default "__VITE_ASSET__2BABKn$n__"